module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0073.jpg?v=388fe335";